import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from 'react-oidc-context';

// Cognito OIDC config (best practice, supports local and prod)
const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-west-2.amazonaws.com/us-west-2_nJFzTpjRV", // OIDC endpoint for your new user pool (with underscore)
  client_id: "2g373h5du3vb1c97gsp0mb8o9l", // New app client ID
  redirect_uri: `${window.location.origin}/auth/callback`,
  response_type: "code",
  scope: "openid email phone",
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
    <App />
    </AuthProvider>
  </React.StrictMode>
);
